<template>
  <div class="first-step-box">
    <a-form-model
      ref="form"
      :model="stepForm"
      :rules="stepRule"
      :label-col="{span:1}"
      :wrapper-col="{span:23}"
    >
      <div class="title-box">
            <span><span style="color:#FAAD14;">第一步：</span><span
              style="color:rgba(0, 0, 0, 0.847058823529412);">设置签署方</span>
                <a-button
                  v-if="!created && this.stepForm.signOptionList&& this.stepForm.signOptionList.length>0" type="primary"
                  @click="resetEvent"
                  style="position:absolute;top: 13px;right: 5px;">重置签章</a-button>
            </span>
      </div>
      <div v-for="(item,index) in stepForm.signOptionList" :key="index">
        <div class="text " style="background-color: #E6F7FF;height: 32px;line-height: 32px;padding-left: 16px"
             @click="removeOption(index)">
          <span>签署方{{ index + 1 }}-{{ item.signType == 1 ? '企业' : '个人' }}</span>
          <a-icon v-if="created" type="close"
                  style="float: right;padding-right: 10px;color: white;margin-top: 6px;font-size: 20px"/>
        </div>
        <div style="font-size:14px;padding-left: 16px;height: 32px;line-height: 32px">
          <span style="color:#F5222D;">*</span>
          <span style="color:rgba(0, 0, 0, 0.427450980392157);"> </span>
          <span
            style=";font-size:12px;color:rgba(0, 0, 0, 0.847058823529412);">{{
              item.signType == 1 ? '全称' : '姓名'
            }}</span>
        </div>
        <a-form-model-item
          label=""
          :colon="false"
          :required="false"
          style="margin-left: 16px;margin-bottom: 8px;width: calc(100% - 32px)"
          :prop="'signOptionList.'+index+'.name'"
          :rules="stepRule['name']"
        >
          <a-input
            v-model="item.name"
            @blur="value=>onItemNameChange(item,index)"
            placeholder="请输入"
            style="width: 100%;"
          ></a-input>
        </a-form-model-item>

        <div v-if="item.signType==1">
          <div style="font-size:14px;padding-left: 16px;height: 32px;line-height: 32px">
            <span style="color:#F5222D;">*</span>
            <span style="color:rgba(0, 0, 0, 0.427450980392157);"> </span>
            <span style=";font-size:12px;color:rgba(0, 0, 0, 0.847058823529412);">统一社会信用代码</span>
          </div>
          <a-form-model-item
            label=""
            :colon="false"
            :required="false"
            style="margin-left: 16px;margin-bottom: 8px;width: calc(100% - 32px)"
            :prop="'signOptionList.'+index+'.code'"
            :rules="stepRule['code']"
          >
            <a-input
              v-model="item.code"
              placeholder="请输入"
              style="width: 100%"></a-input>
          </a-form-model-item>
        </div>
        <div v-else>
          <div style="font-size:14px;padding-left: 16px;height: 32px;line-height: 32px">
            <span style="color:#F5222D;">*</span>
            <span style="color:rgba(0, 0, 0, 0.427450980392157);"> </span>
            <span style=";font-size:12px;color:rgba(0, 0, 0, 0.847058823529412);"> 证件类型</span>
          </div>
          <a-form-model-item
            label=""
            :colon="false"
            :required="false"
            style="margin-left: 16px;margin-bottom: 8px;width: calc(100% - 32px)"
            :prop="'signOptionList.'+index+'.cardType'"
            :rules="stepRule['cardType']"
          >
            <a-select
              v-model="item.cardType"
              placeholder="请输入"
              style="width: 100%">
              <a-select-option
                v-for="item in cardOptions"
                :key="item.key"
                :value="item.key">{{ item.value }}
              </a-select-option>
            </a-select>
          </a-form-model-item>

          <div style="font-size:14px;padding-left: 16px;height: 32px;line-height: 32px">
            <span style="color:#F5222D;">*</span>
            <span style="color:rgba(0, 0, 0, 0.427450980392157);"> </span>
            <span style=";font-size:12px;color:rgba(0, 0, 0, 0.847058823529412);"> 证件号码</span>
          </div>
          <a-form-model-item
            label=""
            :colon="false"
            :required="false"
            style="margin-left: 16px;margin-bottom: 8px;width: calc(100% - 32px)"
            :prop="'signOptionList.'+index+'.code'"
            :rules="stepRule['code']"
          >
            <a-input
              v-model="item.code"
              placeholder="请输入"
              style="width: 100%"></a-input>
          </a-form-model-item>
        </div>
        <div style="font-size:14px;padding-left: 16px;height: 32px;line-height: 32px">
          <span style="color:#F5222D;">*</span>
          <span style="color:rgba(0, 0, 0, 0.427450980392157);"> </span>
          <span style="font-size:12px;color:rgba(0, 0, 0, 0.847058823529412);">签署人手机号</span>
        </div>
        <a-form-model-item
          label=""
          :colon="false"
          :required="false"
          style="margin-left: 16px;margin-bottom: 8px;width: calc(100% - 32px)"
          :prop="'signOptionList.'+index+'.phoneNumber'"
          :rules="stepRule['phoneNumber']"
        >
          <a-input
            v-model="item.phoneNumber"
            placeholder="请输入"
            style="width: 100%"></a-input>
        </a-form-model-item>
        <a-form-model-item label=""
                           :colon="false"
                           :required="false">
          <div class='checked-switch'>
            <span>是否默认签署</span>
            <a-switch checked-children="开" un-checked-children="关" v-model='item.automatic'></a-switch>
          </div>
        </a-form-model-item>
      </div>
      <div class="button-box" v-if="created && stepForm.signOptionList.length<5">
        <a-button @click="addEvent(1)">+ 添加企业</a-button>
        <a-button @click="addEvent(0)" style="margin-left: 10px">+ 添加个人</a-button>
      </div>

    </a-form-model>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'FirstStepComponent',
  props: {
    value: {
      type: Array,
      default: () => []
    },
    //是否是创建模式
    created: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      cardOptions: [],
      stepForm: {
        signOptionList: []
      },
      stepRule: {
        name: [
          { required: !this.created, message: '请输入', trigger: ['blur', 'change'] }
        ],
        cardType: [
          { required: !this.created, message: '请选择证件类型', trigger: ['blur', 'change'] }
        ],
        code: [
          { required: !this.created, message: '请输入', trigger: ['blur', 'change'] },
          { validator: this.validatorCode, trigger: ['blur'] }
        ],
        phoneNumber: [
          { required: !this.created, message: '请输入签署手机号', trigger: ['blur', 'change'] },
          { validator: this.validatorPhoneNumber, trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  watch: {
    'value': function(newVal, oldVal) {
      this.stepForm.signOptionList = newVal ? newVal : []
      this.getLogUtils().logWithTag('内统一', this.stepForm.signOptionList)
    },
    'stepForm.signOptionList': function(newVal, oldVal) {
      this.$emit('input', newVal)
      this.$emit('change', { value: newVal })
    }
  },
  mounted() {
    this.getPactSignCardType()
    this.stepForm.signOptionList = this.value ? this.value : []
  },
  methods: {
    validatorPhoneNumber(rule, value, callback) {
      if (!value || this.getValidatorHelper().validateMobile(value)) {
        callback()
      } else {
        callback(new Error('签署人手机号不合法'))
      }
    },
    validatorCode(rule, value, callback) {
      if (value) {
        let findItem = this.stepForm.signOptionList.find(item => item.code === value)
        if (findItem && findItem.signType === 1) {
          //企业
          let isUnifiedCreditCode = this.getValidatorHelper().isUnifiedCreditCode(value)
          if (isUnifiedCreditCode) {
            callback()
          } else {
            callback(new Error('输入的统一信用代码不合法'))
          }
        } else if (findItem && findItem.signType === 0) {
          //个人,//暂时不做校验。
          callback()
        } else {
          callback()
        }
      } else {
        callback()
      }
    },
    getPactSignCardType() {
      let url = 'pact/getPactSignCardType'
      this.getHttpServices().getServerApiService().get(url).then(list => {
        this.cardOptions = list
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    addEvent(type) {
      if (this.stepForm.signOptionList.length >= 5) {
        this.$message.error('最多支持5个签署方')
        return
      }
      const list = [...this.stepForm.signOptionList]
      const obj = {}
      obj.signType = type
      list.push(obj)
      this.stepForm.signOptionList = list
    },
    onItemNameChange(item, index) {
      this.$emit('onItemNameChange', { value: item.name, item: item, index: index })
    },
    removeOption(index) {
      if (this.created) {
        this.stepForm.signOptionList = this.stepForm.signOptionList.filter((sItem, sIndex) => sIndex !== index)
      }
    },
    validate() {
      return new Promise((resolve) => {
        this.$refs['form'].validate(valid => {
          resolve(valid)
        })
      })
    },
    resetEvent() {
      this.$emit('reset', {})
    }
  }

}
</script>
<style scoped lang="less">
.first-step-box {
  width: 100%;

  .title-box {
    padding-left: 16px;
    height: 55px;
    line-height: 55px;
    background-color: white;
    border-bottom: 1px solid #e9e9e9;
    position: relative;

    span {
      font-size: 16px;
    }
  }

  .button-box {
    padding-top: 20px;
    text-align: center;
  }
}

.checked-switch {
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>